import {createRouter, createWebHashHistory, RouteRecordRaw} from 'vue-router'

const routes: Array<RouteRecordRaw> = [
	{
		path: '/',
		name: 'Home',
		meta: {template: 'Login'},
		component: () => import(/* webpackChunkName: 'login-route' */ '../views/login/Domain.vue')
	},
	{
		path: '/login/domain',
		name: 'Domain',
		meta: {template: 'Login'},
		component: () => import(/* webpackChunkName: 'login-route' */ '../views/login/Domain.vue')
	},
	{
		path: '/login/user-selection',
		name: 'UserSelection',
		meta: {template: 'Login'},
		component: () => import(/* webpackChunkName: 'login-route' */ '../views/login/UserSelection.vue')
	},
	{
		path: '/login/password',
		name: 'Password',
		meta: {template: 'Login'},
		component: () => import(/* webpackChunkName: 'login-route' */ '../views/login/Password.vue')
	},
	{
		path: '/login/verify',
		name: 'verify',
		meta: {template: 'Login'},
		component: () => import(/* webpackChunkName: 'login-route' */ '../views/login/2FA.vue')
	},
	{
		path: '/login/welcome',
		name: 'welcome',
		meta: {template: 'Empty'},
		component: () => import(/* webpackChunkName: 'login-route' */ '../views/login/Welcome.vue')
	},

	//
	//	Reservation Analysis Block
	//

	{
		path: '/backoffice/res-analysis/index',
		name: 'res-analysis-index',
		meta: {template: 'Empty'},
		component: () => import(/* webpackChunkName: 'res-analysis' */ '../views/backoffice/HotelResAnalysis.vue')
	},
	{
		path: '/backoffice/res-analysis/overview',
		name: 'res-analysis-overview',
		meta: {template: 'ResAnalysis'},
		component: () => import(/* webpackChunkName: 'res-analysis' */ '../views/backoffice/HotelResAnalysisOverview.vue')
	},
	{
		path: '/backoffice/res-analysis/diagram',
		name: 'res-analysis-diagram',
		meta: {template: 'ResAnalysis'},
		component: () => import(/* webpackChunkName: 'res-analysis' */ '../views/backoffice/HotelResAnalysisDiagram.vue')
	},
	{
		path: '/backoffice/res-analysis/reservations',
		name: 'res-analysis-reservations',
		meta: {template: 'ResAnalysis'},
		component: () => import(/* webpackChunkName: 'res-analysis' */ '../views/backoffice/HotelResAnalysisReservations.vue')
	},

	//
	//	Reservation Controlling Block
	//

	{
		path: '/reporting/res-controlling/index',
		name: 'res-controlling-index',
		meta: {template: 'Empty'},
		component: () => import(/* webpackChunkName: 'res-controlling' */ '../views/reporting/ResControlling.vue')
	},
	{
		path: '/reporting/res-controlling/overview',
		name: 'res-controlling-overview',
		meta: {template: 'ResControlling'},
		component: () => import(/* webpackChunkName: 'res-controlling' */ '../views/reporting/ResControllingOverview.vue')
	},
	{
		path: '/reporting/res-controlling/diagram',
		name: 'res-controlling-diagram',
		meta: {template: 'ResControlling'},
		component: () => import(/* webpackChunkName: 'res-controlling' */ '../views/reporting/ResControllingDiagram.vue')
	},
	{
		path: '/reporting/res-controlling/reservations',
		name: 'res-controlling-reservations',
		meta: {template: 'ResControlling'},
		component: () => import(/* webpackChunkName: 'res-controlling' */ '../views/reporting/ResControllingReservations.vue')
	},

	//
	//	Excel View Route
	//

	{
		path: '/reporting/excel-view',
		name: 'excel-view',
		meta: {template: 'Empty'},
		component: () => import(/* webpackChunkName: 'excel-view' */ '../views/reporting/ExcelView.vue')
	},

	//
	// FrontofficeChat Route
	//
	{
		path: '/frontoffice/chat-reservation',
		name: 'frontoffice-chat-reservation',
		meta: { template: 'Empty' }, // or whatever fits your layout
		component: () => import(/* webpackChunkName: 'ChatReservationFullScreen' */ '../views/chatReservation/ChatReservationFullScreen.vue')
	},

	//
	//	Date Rate View Routes
	//

	{
		path: '/frontoffice/date-rate-view/config',
		name: 'date-rate-view-config',
		meta: {template: 'DateRateView'},
		component: () => import(/* webpackChunkName: 'date-rate-view' */ '../views/frontoffice/dateRateView/DateRateViewConfig.vue')
	},
	{
		path: '/frontoffice/date-rate-view/results',
		name: 'date-rate-view-results',
		meta: {template: 'DateRateView'},
		component: () => import(/* webpackChunkName: 'date-rate-view' */ '../views/frontoffice/dateRateView/DateRateViewResults.vue')
	},
	{
		path: '/frontoffice/date-rate-view/costs',
		name: 'date-rate-view-costs',
		meta: {template: 'DateRateView'},
		component: () => import(/* webpackChunkName: 'date-rate-view' */ '../views/frontoffice/dateRateView/DateRateViewCosts.vue')
	},
	{
		path: '/frontoffice/date-rate-view/contact',
		name: 'date-rate-view-contact',
		meta: {template: 'DateRateView'},
		component: () => import(/* webpackChunkName: 'date-rate-view' */ '../views/frontoffice/dateRateView/DateRateViewContact.vue')
	},
	{
		path: '/frontoffice/date-rate-view/shipping',
		name: 'date-rate-view-shipping',
		meta: {template: 'DateRateView'},
		component: () => import(/* webpackChunkName: 'date-rate-view' */ '../views/frontoffice/dateRateView/DateRateViewShipping.vue')
	},
	{
		path: '/frontoffice/date-rate-view/onepage',
		name: 'date-rate-view-onepage',
		meta: {template: 'DateRateView'},
		component: () => import(/* webpackChunkName: 'date-rate-view' */ '../views/frontoffice/dateRateView/DateRateViewOnePage.vue')
	}
]

const router = createRouter({
	history: createWebHashHistory(),
	routes
})

export default router
